
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_4pgzf_157",
  "arrow": "awsui_arrow_18eso_4pgzf_157",
  "in-filtering-token-root": "awsui_in-filtering-token-root_18eso_4pgzf_217",
  "in-filtering-token-nested": "awsui_in-filtering-token-nested_18eso_4pgzf_217",
  "has-caret": "awsui_has-caret_18eso_4pgzf_253",
  "placeholder": "awsui_placeholder_18eso_4pgzf_256",
  "pressed": "awsui_pressed_18eso_4pgzf_269",
  "disabled": "awsui_disabled_18eso_4pgzf_272",
  "in-filtering-token": "awsui_in-filtering-token_18eso_4pgzf_217",
  "readonly": "awsui_readonly_18eso_4pgzf_293",
  "invalid": "awsui_invalid_18eso_4pgzf_318",
  "warning": "awsui_warning_18eso_4pgzf_327",
  "custom-option": "awsui_custom-option_18eso_4pgzf_336",
  "inline-tokens": "awsui_inline-tokens_18eso_4pgzf_341"
};
  